export const config = {
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://daddy-and-chris-api-445316453320.us-central1.run.app'
} as const; 